import { Box, Card, Divider, FormGroup, Grid, IconButton, InputAdornment, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";

import { Collections, Contacts, FileCopy, FlightLand, FlightTakeoff, InfoRounded } from '@mui/icons-material';
import React, { useContext, useState } from 'react'
import { useFieldArray } from 'react-hook-form';
import BSSPreventivoContext from '../../../contexts/BSSPreventivoContext';
import BSSStyleContext from '../../../contexts/BSSStyleContext';
import currencies from '../../../currencies';

import useBSSLogger from "../../../hooks/useBSSLogger";
import { width2Breakpoint } from '../../../lib/theming';
import __t from '../../../lib/traduzioni';
import BSSNumber from '../../form/BSSNumber';
import BSSSwitch from '../../form/BSSSwitch';
import BSSText from '../../form/BSSText';
import { _Pacchi } from '../Pacchi';
import { labelCollo, labelIndiceCollo, labelLocalita } from './FrammentoRiepilogo';

const {logger} = useBSSLogger()

const styles = makeStyles((theme) => {

    const desktop = theme.breakpoints.up("lg");
    const mobile = theme.breakpoints.down("md");


    const obj = {
        root: {
            display: 'flex',
        },
        content: {
            flex: '1',        
        },        
    }

    return obj;
})

const FrammentoMerce = ({classes, methods}) => {

    const {datiPregressi, preventivoStorage, tipiSpedizione} = useContext(BSSPreventivoContext)

    const {preventivi = [], tipoSelezionato} = preventivoStorage;

    const tipoSelezionatoRT = tipiSpedizione.find(t => t.id === tipoSelezionato)

    const valuta = currencies[preventivi?.currency ?? "EUR"];

    const {control} = methods;

    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control,
        name: "colli",
    });  

    const copia = naturamerce => {


        const valoriiniziali = methods.getValues("colli");

        logger.debug("applico la stessa natura merce a tutti i colli", naturamerce, valoriiniziali);

        valoriiniziali.forEach((collo, indice) => {
            methods.setValue(`colli.${indice}.naturamerce`, naturamerce)
        })
        
    }

    const colli = methods.getValues(`colli`);
    const ncolli = colli?.length ?? 0;
    const [mostraMisure, setMostraMisure] = useState(Array
        .from({length: ncolli})
        .reduce((obj, v) => ({
            ...obj,
            [v]: false
        }), {})
    )

    
    return (
        <Box width={1}>
            <Grid item className={classes.formGroupBox} >
            

                <Card>
                    <Box px={2}>
                        
                            <Typography variant="h6">
                                <Grid container style={{ display: "flex" }} justify="space-between">                                                    

                                    {__t("valore")} {__t("e")} {__t("natura")} {__t("dellamerce")}
                                    
                                </Grid>
                            </Typography>
                    </Box>
                    
                
                    <Divider />

                    <Box p={2}>
                        <FormGroup row>
                            <Box width={1} 
                                mb={"1.2em"}>


                                <BSSNumber
                                    name={`valmerce`} 
                                    label={__t("valmerce")}    
                                    methods={methods}                                     
                                    NumberFormatProps={{
                                        decimalScale: valuta?.decimal_digits ?? 2,
                                        InputProps: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Divider orientation="vertical" />
                                                    {valuta.symbol}                                                
                                                </InputAdornment>
                                            )
                                        }     
                                    }}
                                    ControllerProps={{
                                        rules: {
                                            required: __t("validazione.requiredField", [__t("valmerce")]),
                                            // min: {value: 0.01, message: __t("validazione.min", [0.01])}
                                        },   

                                    }}                                           
                                />  

                            </Box>                                                                                        
                        </FormGroup>
                        
                            <Typography variant="h6">
                                {tipoSelezionatoRT?.descrizione ?? ""}
                            </Typography>

                            {fields.map((item, index) => {

                                const collo = methods.getValues(`colli.${index}`);
                                const {lunghezza = 0, altezza = 0, larghezza = 0, peso = 0, qta = 0, natura = ""} = collo


                                return (
                                    <Box my={2} key={item.id}>

                                        
                                        
                                        <FormGroup row>
                                            
                                            {/* {`#${index+1} ${labelCollo({...collo})} `} */}
                                            <BSSText
                                                name={`colli.${index}.naturamerce`} 
                                                methods={methods}            
                                                TextFieldProps={{
                                                    title: `#${index+1} ${labelCollo({...collo})} `,
                                                    label: `${__t("natmerce")} #${index+1}`
                                                }}                                      
                                                TextFieldInputProps={{  
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconButton size="small" color="primary" onClick={e => setMostraMisure({...mostraMisure, [index]: !mostraMisure[index]})}>
                                                                <InfoRounded /> 
                                                                <Typography variant="caption" itemType="span" >
                                                                    {mostraMisure[index] ? `${labelCollo({...collo})}` : ''}
                                                                </Typography>
                                                            </IconButton>
                                                            
                                                        </InputAdornment>
                                                    ),                                                  
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton size="small" color="primary" onClick={e => copia(methods.getValues(`colli.${index}.naturamerce`))}>
                                                                <FileCopy />
                                                            </IconButton>
                                                            
                                                        </InputAdornment>
                                                    )
                                                }}     
                                                ControllerProps={{
                                                    rules: {
                                                        required: __t("validazione.requiredField", [__t("natmerce")])
                                                    }
                                                }}                                                                            
                                            />

                                        </FormGroup>
                                    </Box>    
                                )

                            })}      
                    </Box>                    
                </Card>

                {/* <pre>{JSON.stringify(methods.getValues(), null, 2)}</pre> */}

            </Grid>

        </Box>
    )
}

export default FrammentoMerce;